//销售机构
import { axios } from '@/utils/request';
//列表
const getListData = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/manager/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//保存
const saveManager = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/investment/manager/save',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//批量删除
const deleteBatch = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_PRODUCT +
      '/product/investment/manager/deleteBatch',
    method: 'post',
    data: params
  });
};
//根据id删除
const deleteById = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/investment/manager/delete',
    method: 'post',
    data: params
  });
};

export { getListData, saveManager, deleteBatch, deleteById };
